export interface ISheetColumns {
  stt?: number;
  prompt?: number;
  content?: number;
  date?: number;
  time?: number;
  status?: number;
  checked?: number;
}

export interface IN8NWorkflow {
  _id: string;
  name: string;
  description: string;
  type: string;
  status: 'active' | 'inactive';
  documentUrl: string;
  sheetUrl: string;
  googleSheetUrl: string;
  aiModel?: string;
  aiPromptTemplate: string;
  facebookPageId?: string;
  websiteUrl?: string;
  checkInterval: number;
  sheetColumns?: ISheetColumns;
  n8nWorkflowId?: string;
  totalExecutions: number;
  successfulExecutions: number;
  failedExecutions: number;
  lastExecutedAt?: string;
  lastError?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface ICreateN8NWorkflowRequest {
  name: string;
  description?: string; // Auto-generated if not provided
  type: string;
  status: 'active' | 'inactive';
  documentUrl?: string; // Auto-generated from googleSheetUrl if not provided
  sheetUrl?: string; // Auto-generated from googleSheetUrl if not provided
  googleSheetUrl: string;
  googleClientId?: string; // User's Google OAuth Client ID
  googleClientSecret?: string; // User's Google OAuth Client Secret
  googleSheetApiKey?: string; // Optional - deprecated in favor of OAuth2
  googleSheetsCredentialId?: string; // n8n Credential ID (created after OAuth)
  aiModel: string; // Now required (gpt-4, gpt-4o-mini, etc)
  aiApiKey: string;
  aiPromptTemplate?: string; // Auto-generated with default template if not provided
  facebookPageId?: string;
  facebookAccessToken?: string;
  websiteUrl?: string;
  websiteApiKey?: string;
  websiteUsername?: string;  // WordPress username for website_poster
  websitePassword?: string;  // WordPress application password for website_poster
  checkInterval?: number; // Default: 300 seconds
  // sheetColumns is auto-generated by backend (fixed: STT=0, PROMPT=1, CONTENT=2, DATE=3, TIME=4, STATUS=5, CHECKED=6)
  sheetColumns?: ISheetColumns;
}

export interface IUpdateN8NWorkflowRequest extends Partial<ICreateN8NWorkflowRequest> { }

export interface IN8NWorkflowsRequest {
  currentPage?: number;
  pageSize?: number;
  search?: string;
  type?: string;
  status?: 'active' | 'inactive';
}

export interface IN8NWorkflowExecution {
  _id: string;
  workflowId: string;
  status: 'success' | 'failed' | 'running';
  startedAt: string;
  finishedAt?: string;
  error?: string;
  result?: any;
  duration?: number;
}

export enum N8NWorkflowType {
  FACEBOOK_REPLY = 'facebook_reply',
  WEBSITE_SCRAPER = 'website_scraper',
  SHEET_PROCESSOR = 'sheet_processor',
  WEBSITE_POSTER = 'website_poster'
}

export enum N8NWorkflowStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}